export const boardMembersTour = {
  key: "boardMembers",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-members-reports"]',
      content: t("Tour_BoardMembers_Reports"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-members-bilan"]',
      content: t("Tour_BoardMembers_Bilan"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-members-workload"]',
      content: t("Tour_BoardMembers_Workload"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-members-changeowner"]',
      content: t("Tour_BoardMembers_ChangeOwner"),
      placement: "left",
    },
    {
      target: '[data-tour="board-members-leave"]',
      content: t("Tour_BoardMembers_Leave"),
      placement: "left",
    },
    {
      target: '[data-tour="board-members-tabs"]',
      content: t("Tour_BoardMembers_Tabs"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-members-list"]',
      content: t("Tour_BoardMembers_List"),
      placement: "top",
    },
  ],
};
